import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import productBadgeMessages from 'i18n/productBadgeMessages'
import Caption from 'LuxKit/Typography/Caption'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'

interface Props {
  saleOnDepartures?: boolean
}

export default function TourDiscountLabel(props: Props) {
  const { saleOnDepartures = false } = props
  const intl = useIntl()

  return (
    <MessagingLabel variant="urgency" startIcon={<SolidFireIcon />}>
      {saleOnDepartures && <FormattedMessage
        id="xPLC1Df4MsKSXvXv5Ak6"
        defaultMessage="Limited Time Special <departures>(select departures)</departures>"
        
        values={{ departures: (chunks: React.ReactNode) => <Caption variant="small" as="span">{chunks}</Caption> }}
      />}
      {!saleOnDepartures && intl.formatMessage(productBadgeMessages.limitedTimeSpecial)}
    </MessagingLabel>
  )
}
